import type { NetworkProductRanking, NetworkProductRankingSelectionParams } from '@gozoki/api-types'
import { keepPreviousData, type UseQueryResult, useQuery } from '@tanstack/react-query'
import { fetchNetworkProductRanking } from '../queries/networkProductRanking.queries'

export const useNetworkProductRanking = (
  selection: NetworkProductRankingSelectionParams,
  enabled = true,
): UseQueryResult<NetworkProductRanking, unknown> =>
  useQuery({
    queryKey: [
      'get-network-product-ranking',
      selection.storeIds,
      selection.storeAgeFilter,
      selection.ageStoreIds,
      selection.startDate,
      selection.endDate,
      selection.cohortUnit,
      selection.cohortValue,
      selection.categoryIds,
      selection.indicator,
      selection.productReference,
    ],
    queryFn: () => fetchNetworkProductRanking(selection),
    placeholderData: keepPreviousData,
    enabled,
  })
